"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Note = exports.TotpCodes = exports.OfficeFolder = exports.Office = exports.File = exports.DocumentType = exports.DocumentHistory = exports.Document = exports.DeedType = exports.Deed = exports.Contact = exports.Address = void 0;
const Customer_1 = __importDefault(require("./Customer"));
exports.default = Customer_1.default;
var Address_1 = require("./Address");
Object.defineProperty(exports, "Address", { enumerable: true, get: function () { return __importDefault(Address_1).default; } });
var Contact_1 = require("./Contact");
Object.defineProperty(exports, "Contact", { enumerable: true, get: function () { return __importDefault(Contact_1).default; } });
var Deed_1 = require("./Deed");
Object.defineProperty(exports, "Deed", { enumerable: true, get: function () { return __importDefault(Deed_1).default; } });
var DeedType_1 = require("./DeedType");
Object.defineProperty(exports, "DeedType", { enumerable: true, get: function () { return __importDefault(DeedType_1).default; } });
var Document_1 = require("./Document");
Object.defineProperty(exports, "Document", { enumerable: true, get: function () { return __importDefault(Document_1).default; } });
var DocumentHistory_1 = require("./DocumentHistory");
Object.defineProperty(exports, "DocumentHistory", { enumerable: true, get: function () { return __importDefault(DocumentHistory_1).default; } });
var DocumentType_1 = require("./DocumentType");
Object.defineProperty(exports, "DocumentType", { enumerable: true, get: function () { return __importDefault(DocumentType_1).default; } });
var File_1 = require("./File");
Object.defineProperty(exports, "File", { enumerable: true, get: function () { return __importDefault(File_1).default; } });
var Office_1 = require("./Office");
Object.defineProperty(exports, "Office", { enumerable: true, get: function () { return __importDefault(Office_1).default; } });
var OfficeFolder_1 = require("./OfficeFolder");
Object.defineProperty(exports, "OfficeFolder", { enumerable: true, get: function () { return __importDefault(OfficeFolder_1).default; } });
var TotpCodes_1 = require("./TotpCodes");
Object.defineProperty(exports, "TotpCodes", { enumerable: true, get: function () { return __importDefault(TotpCodes_1).default; } });
var Note_1 = require("./Note");
Object.defineProperty(exports, "Note", { enumerable: true, get: function () { return __importDefault(Note_1).default; } });
